import { render, staticRenderFns } from "./change-password-dialog.vue?vue&type=template&id=425cf6c8"
import script from "./change-password-dialog.vue?vue&type=script&lang=ts"
export * from "./change-password-dialog.vue?vue&type=script&lang=ts"
import style0 from "./change-password-dialog.vue?vue&type=style&index=0&id=425cf6c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports